// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalProjectEdit_base__3Ekas","label":"useModalProjectEdit_label__1NEP1"};